import { __decorate } from "tslib";
import { css, html, LitElement } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { customElement, property } from 'lit/decorators.js';
import { when } from 'lit/directives/when.js';
import { Size as TagSize } from './enums/size.js';
import { TagEvent } from './enums/tag-event.js';
import './viedoc-icon-button.js';
export { TagSize };
let ViedocTag = class ViedocTag extends LitElement {
    constructor() {
        super(...arguments);
        this.removable = false;
        this.size = TagSize.Medium;
    }
    emitRemove() {
        this.dispatchEvent(new Event(TagEvent.Remove, {
            bubbles: true,
            composed: true,
        }));
    }
    // Dispatch remove event on button click
    handleRemoveClick(event) {
        event.stopPropagation();
        this.emitRemove();
    }
    // Dispatch remove event on Enter or Space
    handleRemoveKeydown(event) {
        const { code } = event;
        if (['Enter', 'Space'].includes(code)) {
            event.preventDefault();
            event.stopPropagation();
            this.emitRemove();
        }
    }
    render() {
        const classNames = classMap({
            tag: true,
            [`tag--removable`]: this.removable,
            [`tag--${this.size}`]: true,
        });
        return html `<span class=${classNames}>
      <slot class="tag__content"></slot>
      ${when(this.removable, () => html `<viedoc-icon-button
            class="tag__remove"
            aria-label="Remove"
            icon="delete"
            @click=${this.handleRemoveClick}
            @keydown=${this.handleRemoveKeydown}
            size="small"
          ></viedoc-icon-button>`)}
    </span>`;
    }
};
ViedocTag.styles = [
    css `
      :host {
        display: inline-block;
      }

      .tag {
        display: flex;
        align-items: center;

        border-radius: 6px;
        background-color: var(--primary-background-color);

        -webkit-font-smoothing: antialiased;
        font-family: var(--font-family-monument);
        font-size: var(--font-size-xs);
        font-weight: 400;
        white-space: nowrap;

        gap: 0.5rem; /* 8px */
        padding: 0.25rem 0.75rem; /* 4px 12px */
        box-sizing: border-box;
        min-height: 1.813rem; /* 29px */
      }

      .tag__content {
        display: flex;
        white-space: normal;
      }

      .tag--removable {
        padding-right: 0.438rem; /* 7px */
      }

      .tag__remove {
        display: flex;

        --icon-button-size-small: 1.25rem; /* 20px */
        --icon-background-color: var(--neutral-color);
      }

      .tag__remove:hover {
        --icon-background-color: var(--neutral-highlight-color);
      }

      /* -- TAG SIZES -- */

      .tag--small {
        gap: 0.375rem; /* 6px */
        padding: 0.125rem 0.375rem; /* 2px 6px */
        min-height: 1.688rem; /* 27px */
      }

      .tag--small.tag--removable {
        padding-right: 0.25rem; /* 4px */
      }

      .tag--large {
        padding-top: 0.438rem; /* 7px */
        padding-bottom: 0.438rem;
        min-height: 2.125rem; /* 34px */
      }
    `,
];
__decorate([
    property({ type: Boolean })
], ViedocTag.prototype, "removable", void 0);
__decorate([
    property({ type: String })
], ViedocTag.prototype, "size", void 0);
ViedocTag = __decorate([
    customElement('viedoc-tag')
], ViedocTag);
export { ViedocTag };
